var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatBubble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71426 7.4285C3.71426 6.79732 4.22593 6.28564 4.85711 6.28564C5.4883 6.28564 5.99997 6.79732 5.99997 7.4285C5.99997 8.05968 5.4883 8.57136 4.85711 8.57136C4.22593 8.57136 3.71426 8.05968 3.71426 7.4285Z",
    fill: "black",
    fillOpacity: 0.52
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.42854 7.4285C7.42854 6.79732 7.94021 6.28564 8.57139 6.28564C9.20257 6.28564 9.71425 6.79732 9.71425 7.4285C9.71425 8.05968 9.20257 8.57136 8.57139 8.57136C7.94021 8.57136 7.42854 8.05968 7.42854 7.4285Z",
    fill: "black",
    fillOpacity: 0.52
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1429 7.4285C11.1429 6.79732 11.6546 6.28564 12.2857 6.28564C12.9169 6.28564 13.4286 6.79732 13.4286 7.4285C13.4286 8.05968 12.9169 8.57136 12.2857 8.57136C11.6546 8.57136 11.1429 8.05968 11.1429 7.4285Z",
    fill: "black",
    fillOpacity: 0.52
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.85714 1.14286C2.70559 1.14286 2.56024 1.20306 2.45308 1.31022C2.34591 1.41739 2.28571 1.56273 2.28571 1.71429V12C2.28571 12.0614 2.27581 12.1224 2.25639 12.1807L1.44271 14.6217L5.00426 13.7313C5.04959 13.72 5.09613 13.7143 5.14285 13.7143H14.2857C14.4373 13.7143 14.5826 13.6541 14.6898 13.5469C14.7969 13.4398 14.8571 13.2944 14.8571 13.1429V1.71429C14.8571 1.56273 14.7969 1.41739 14.6898 1.31022C14.5826 1.20306 14.4373 1.14286 14.2857 1.14286H2.85714ZM1.64496 0.502103C1.96645 0.180612 2.40248 0 2.85714 0H14.2857C14.7404 0 15.1764 0.180612 15.4979 0.502103C15.8194 0.823593 16 1.25963 16 1.71429V13.1429C16 13.5975 15.8194 14.0336 15.4979 14.355C15.1764 14.6765 14.7404 14.8571 14.2857 14.8571H5.2132L0.710017 15.9829C0.507683 16.0335 0.293862 15.9699 0.152155 15.8168C0.0104488 15.6638 -0.0366323 15.4457 0.0293204 15.2479L1.14285 11.9073V1.71429C1.14285 1.25963 1.32347 0.823594 1.64496 0.502103Z",
    fill: "black",
    fillOpacity: 0.52
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubble);
export default __webpack_public_path__ + "static/media/chatBubble.705bb66bc9598d6b1cc9dbad98f01ede.svg";
export { ForwardRef as ReactComponent };